module.exports = __webpack_public_path__ + "static/media/orderHardCardsEng.6a2109d8.jpg";